import React, { useEffect } from "react";
import "./Blogs.css";
import b1 from "../assets/Blog_1.jpg";
import b2 from "../assets/Blog_2.jpg";
import b3 from "../assets/Blog_3.jpg";
import b4 from "../assets/Blog_4.jpg";
import b5 from "../assets/Blog_5.jpg";

const Blogs = () => {
  useEffect(() => {
    document.title = "Blogs | Qnexa Services — Engineering & Inspection Specialists";
  }, []);

  const posts = [
    {
      id: 1,
      title: "The Importance of Third-Party Inspection in Oil & Gas Projects",
      img: b1,
      link: "/blog/1",
    },
    {
      id: 2,
      title: "Why Pipeline Integrity Management Matters in 2025",
      img: b2,
      link: "/blog/2",
    },
    {
      id: 3,
      title: "How Inspection Digitization Improves Project Efficiency",
      img: b3,
      link: "/blog/3",
    },
    {
      id: 4,
      title: "The Role of Welding Inspection in Achieving Product Quality",
      img: b4,
      link: "/blog/4",
    },
    {
      id: 5,
      title: "Why Vendor Assessment is Vital Before Procurement",
      img: b5,
      link: "/blog/5",
    },
  ];

  return (
    <div className="blogs-page">
      <div className="blogs-banner">
        <h1>Our Blogs</h1>
        <p className="blogs-subtitle">Expert insights from Qnexa Services</p>
      </div>

      <div className="blogs-body">
        <div className="blogs-grid">
          {posts.map((p) => (
            <article className="blog-card" key={p.id}>
              <div className="blog-image">
                <img src={p.img} alt={p.title} />
              </div>

              <div className="blog-content">
                <h3 className="blog-title">{p.title}</h3>

                <a className="read-more" href={p.link}>
                  Read more <span className="arrow">→</span>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blogs;
